import { useEffect, useRef } from 'react'
import { useConnectionState, useLocalParticipant } from '@livekit/components-react'
import { ConnectionState } from 'livekit-client'

export const useApplyParticipantName = (name?: string) => {
  const { localParticipant } = useLocalParticipant()
  const connectionState = useConnectionState()
  const hasAppliedRef = useRef(false)

  useEffect(() => {
    const trimmed = name?.trim()

    if (
      !trimmed ||
      !localParticipant ||
      connectionState !== ConnectionState.Connected ||
      hasAppliedRef.current
    ) {
      return
    }

    hasAppliedRef.current = true

    localParticipant.setName(trimmed).catch(() => {
      hasAppliedRef.current = false
    })
  }, [connectionState, localParticipant, name])
}
